import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'prop-types';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconUserSettings = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsxs(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("path", {
      d: "M.75 17.25a6.753 6.753 0 019.4-6.208",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      clipRule: "evenodd",
      d: "M7.5 9a4.125 4.125 0 100-8.25A4.125 4.125 0 007.5 9zM17.25 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      clipRule: "evenodd",
      d: "M18.524 10.7l.442 1.453c.151.5.665.798 1.174.68l1.472-.34a1.34 1.34 0 011.275 2.218l-1.031 1.11a1 1 0 000 1.363l1.031 1.11a1.339 1.339 0 01-1.275 2.219l-1.472-.341a.994.994 0 00-1.174.68l-.442 1.448a1.33 1.33 0 01-2.548 0l-.442-1.453a.994.994 0 00-1.174-.681l-1.472.34a1.339 1.339 0 01-1.275-2.217l1.031-1.111a1 1 0 000-1.362l-1.031-1.111a1.339 1.339 0 011.275-2.218l1.472.34a.994.994 0 001.174-.68l.442-1.453a1.33 1.33 0 012.548.006v0z",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
});
IconUserSettings.displayName = "IconUserSettings";

export { IconUserSettings };
